<template>
    <div class="co-email-signatario">
        <v-combobox
            ref="emailSignatario"
            v-model="value.email"
            v-validate="validarCampo"
            :class="campoRequerido ? 'required-field' : ''"
            :error-messages="coletarErros(errors)"
            :items="signatarios.concat(sugestoes)"
            :no-data-text="noDataText"
            :disabled="desabilitarCampo"
            name="E-mail"
            label="E-mail"
            :label="placeholder"
            :placeholder="placeholder"
            item-text="text"
            persistent-placeholder
            @keyup="checarInputParaExibirSugestaoEmail"
            @input="onInputEmail"
        >
        </v-combobox>

        <div v-if="descricao" class="hint-checkbox">
            {{ descricaoCampo }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmailSignatario',
    props: {
        value: {
            required: true
        },
        campoRequerido: {
            type: Boolean,
            default: false
        },
        desabilitarCampo: {
            type: Boolean
        },
        descricao: {
            type: Boolean
        },
        signatariosSugestoes: {
            type: Array,
            required: false,
            default: () => []
        },
        formScope: {
            type: String,
            required: false,
            default: null
        }
    },
    mounted() {
        this.transformarSignatariosEmail()
    },
    data() {
        return {
            sugestoes: [],
            signatarios: [],
            sugestoesDominioLista: ['gmail.com', 'outlook.com', 'hotmail.com', 'live.com', 'uol.com.br', 'bol.com.br', 'yahoo.com', 'yahoo.com.br'],
            descricaoCampo: `Forma de comunicação entre as duas partes (Quem elaborou o documento e o ${this.$tc("pt_br.signatario").toLowerCase()})`
        }
    },
    computed: {
        noDataText() {
            return `Não há ${this.$tc("pt_br.signatario", 2).toLowerCase()} cadastrados.`
        },
        placeholder() {
            return `E-mail do ${this.$tc("pt_br.signatario").toLowerCase()}`
        },
        validarCampo() {
            return this.campoRequerido ? 'required|email' : ''
        }
    },
    methods: {
        coletarErros(e) {
            if (this.formScope !== null) {
                return e.collect('E-mail', this.formScope)
            }

            return e.collect('E-mail')
        },
        checarInputParaExibirSugestaoEmail(e) {
            const valorInput = e.currentTarget.value

            if (!valorInput) {
                this.sugestoes = []
                return
            }

            if (valorInput.includes('@')) {
                this.montarSugestoesEmail(valorInput)
            } else {
                this.sugestoes = []
            }
        },
        focus(e) {
            this.$refs.emailSignatario.focus();
            this.sugestoes = []

            if (!!e.currentTarget.value) {
                this.checarInputParaExibirSugestaoEmail(e)
            }
        },
        montarSugestoesEmail(inputAtual) {
            this.sugestoes = []

            this.sugestoesDominioLista.forEach(sugestaoEmail => {
                const inputAtualSemDominio = inputAtual.replace(/@.*/, '@')
                if (this.signatariosSugestoes.includes(inputAtualSemDominio + sugestaoEmail)) return

                this.sugestoes.push({text: inputAtualSemDominio + sugestaoEmail})
            })
        },
        onInputEmail(val) {
            if (val && val.text) {
                this.value.email = val.text
            }
        },
        transformarSignatariosEmail() {
            if (this.signatariosSugestoes !== undefined && this.signatariosSugestoes.length) {
                this.signatarios = this.signatariosSugestoes.map(signatario => {
                    return {
                        text: signatario.email
                    }
                })
            }
        }
    }
}
</script>
